import { render, staticRenderFns } from "./ImportReceipt.vue?vue&type=template&id=4dcb1035"
import script from "./ImportReceipt.vue?vue&type=script&lang=js"
export * from "./ImportReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports